import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saQosFlowAccessibilityCellChartConfig } from '../cellChartConfigs';

interface QosFlowAccessibilitySaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const QosFlowAccessibilitySaCell: React.FC<QosFlowAccessibilitySaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saQosFlowAccessibilityCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default QosFlowAccessibilitySaCell;
